export default __webpack_public_path__ + "static/media/award.6c405bbb.gif";